<div class="media-category-result">
  <div class="container-fluid">
    <div class="bg-white mt-4">
      <div class="row">
        <div class="col-auto">
          <h5 class="ps-2">
            Media Categories
            <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h5>
        </div>

       

        <div class="col">

          <button class="btn btn-primary float-end" (click)="openMediaCategoryPopup(null)" *ngIf="showAddButton"><i class="fa fa-plus"></i> Add</button>
          <button class="btn btn-primary float-end me-1" (click)="downloadMediaCategory()" *ngIf="showAddButton"><i class="fa fa-download"></i> Export</button>
          <button class="btn btn-outline-primary float-end me-1" [disabled]="!isUpdated" (click)="updateTable()" *ngIf="showAddButton"><i class="fa fa-save"></i> Update Sorting</button>
          <app-search-box placeholder="Search..." class="float-end w-25 me-2"
                          (searchChange)="applyFilter($event)" *ngIf="isUseInternalSearch">
          </app-search-box>
        </div>


      </div>
      <div class="table  data-grid mt-1" #table>

        <table mat-table
               [dataSource]="dataSource"
               cdkDropList
               #table1
               [cdkDropListData]="dataSource.data"
               cdkDragBoundary=".data-grid"
               (cdkDropListDropped)="drop($event)"
               id="table1"
               class="table table-hover"
               matSort="categorySort"
               infiniteScroll
               [infiniteScrollDistance]="1"
               [infiniteScrollThrottle]="100"
               [infiniteScrollContainer]="table"
               [fromRoot]="true"
               (scrolled)="onTableScroll()">

          <ng-container matColumnDef="drag">
            <th mat-header-cell
                class="category-heading w-3-rem" [ngClass]="topClass" style="width:5%"
                *matHeaderCellDef></th>
            <td mat-cell
                cdkDragHandle
                *matCellDef="let element; let i = index"
                [class.moved]="i === newLocation">
              <span class="dragCursor">
                <i class="fa fa-arrows-alt text-primary"></i>
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="select">
            <th mat-header-cell
                *matHeaderCellDef
                class="checkbox-row w-3-rem" [ngClass]="topClass" style="width:5%"
                [hidden]="!isSelectionMode">
              <mat-checkbox (change)="masterToggle($event)"
                            [checked]="selectedIdsSet.size > 0 && isAllSelected()"
                            [indeterminate]="selectedIdsSet.size > 0 && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell
                *matCellDef="let row; let i = index"
                class="checkbox-row"
                cdkDragHandle
                [class.moved]="i === newLocation"
                [hidden]="!isSelectionMode">

              <mat-checkbox [(ngModel)]="row.isSelected"
                            (change)="onCheckboxChange()">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="mediaCategoryName">
            <th mat-header-cell
                class="category-heading w-6-rem cursor-pointer" [ngClass]="topClass"
                (click)="sortTable('name')" style="width:17%"
                *matHeaderCellDef>
              Category Name <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell cdkDragHandle *matCellDef="let element; let i = index" [class.moved]="i === newLocation">{{ element.name }}</td>
          </ng-container>

          <ng-container matColumnDef="mediaGroup">
            <th mat-header-cell
                class="media-group-heading w-6-rem cursor-pointer" [ngClass]="topClass"
                (click)="sortTable('mediaGroupName')" style="width:9%"
                *matHeaderCellDef>
              Group <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell cdkDragHandle *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
              {{ element.mediaGroupName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="leftOrRight">
            <th mat-header-cell
                class="media-side-heading w-3-rem cursor-pointer" [ngClass]="topClass"
                (click)="sortTable('leftOrRight')" style="width:8%"
                *matHeaderCellDef>
              Side <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell cdkDragHandle *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
              {{ element.leftOrRight }}
            </td>
          </ng-container>

          <ng-container matColumnDef="foreOrHind">
            <th mat-header-cell
                class="media-side-heading w-3-rem cursor-pointer" [ngClass]="topClass"
                (click)="sortTable('foreOrHind')" style="width:8%"
                *matHeaderCellDef>
              Fore/Hind <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell cdkDragHandle *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
              {{ element.foreOrHind }}
            </td>
          </ng-container>

          <ng-container matColumnDef="shortName">
            <th mat-header-cell
                class="name-variation-heading w-6-rem cursor-pointer" [ngClass]="topClass"
                (click)="sortTable('shortName')" style="width:25%"
                *matHeaderCellDef>
              Short Name <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell cdkDragHandle *matCellDef="let element; let i = index"  [class.moved]="i === newLocation">
              {{ element.shortName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell
                class="action-heading w-3-rem cursor-pointer" [ngClass]="topClass" style="width:13%;text-align:center"
                *matHeaderCellDef>
              Action
            </th>
            <td mat-cell cdkDragHandle *matCellDef="let element; let i = index" [class.moved]="i === newLocation" style="text-align:center">
              <button type="button"
                      *ngIf="showAddButton"
                      (click)="openMediaCategoryNamesPopup(element)"
                      class="btn btn-outline-primary btn-sm">
                <i class="fa fa-plus"></i>
              </button>
              <button type="button"
                      (click)="openMediaCategoryPopup(element)"
                      class="btn btn-outline-primary btn-sm ms-1">
                <i class="far fa-edit"></i>
              </button>
              <button type="button"
                      (click)="deleteMediaCategory(element)"
                      class="btn btn-outline-danger btn-sm ms-1">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="moveup">
            <th mat-header-cell
                class="category-heading w-3-rem" [ngClass]="topClass" style="width: 5%; white-space: nowrap;"
                *matHeaderCellDef>
              Move Up
            </th>
            <td mat-cell cdkDragHandle
                *matCellDef="let element; let i = index"
                [class.moved]="i === newLocation">
              <span role="button">
                <i class="fa fa-arrow-up"
                   (click)="moveItem($event, i, i - 1)"></i>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="movedown">
            <th mat-header-cell
                class="category-heading w-3-rem" [ngClass]="topClass" style="width: 5%; white-space: nowrap;"
                *matHeaderCellDef>
              Move Down
            </th>
            <td cdkDragHandle mat-cell
                *matCellDef="let element; let i = index"
                [class.moved]="i === newLocation">
              <span role="button">
                <i class="fa fa-arrow-down"
                   (click)="moveItem($event, i, i + 1)"></i>
              </span>
            </td>
          </ng-container>

          <tr mat-header-row
              *matHeaderRowDef="displayedColumns$.value"></tr>
          <tr mat-row
              *matRowDef="let row; columns: displayedColumns$.value; let vetUserIndex = index"
              class="border-start-0 border-end-0 pointer pt-2"
              cdkDrag
              [cdkDragDisabled]="isSalesCompany">
          </tr>

        </table>
          <!--<div class="col-md-12 text-center" *ngIf="isLoader">
              Loading <i class="fa fa-spinner fa-spin"></i>
          </div>-->
      </div>
    </div>
  </div>
</div>
